<div class="notification-settings-dialog">

  <!-- Header -->
  <h2 mat-dialog-title
      class="flex items-center gap-2 bg-pmdf-bg-subtle p-4 border-b border-pmdf-divider">
    <mat-icon class="text-pmdf-primary icon-base">settings</mat-icon>
    <span class="text-pmdf-text-primary text-lg">Configurações de Notificações</span>
  </h2>

  <mat-dialog-content class="dialog-content">
    <!-- Status consolidado -->
    <div class="mb-4 space-y-1.5">
      <div class="flex items-center gap-2 rounded-pmdf-card px-3 py-2"
        [class]="store.isPushActive() ? 'bg-pmdf-success-soft text-pmdf-success' : 'bg-pmdf-bg-muted text-pmdf-muted-55'">
        <span class="h-2 w-2 rounded-full"
          [class]="store.isPushActive() ? 'bg-pmdf-success' : 'bg-pmdf-border-strong'"></span>
        <span class="text-sm font-medium">
          Push: {{ store.isPushActive() ? 'Ativo' : 'Inativo' }}
        </span>
        @if (!store.isPushActive()) {
          <button mat-stroked-button class="ml-auto text-xs! min-h-[28px]! h-7! px-2!"
            (click)="onActivatePush()" [disabled]="activatingPush()">
            {{ activatingPush() ? 'Ativando...' : 'Ativar agora' }}
          </button>
        }
      </div>
      <div class="flex items-center gap-2 rounded-pmdf-card px-3 py-2"
        [class]="store.isConnected() ? 'bg-pmdf-success-soft text-pmdf-success' : 'bg-pmdf-bg-muted text-pmdf-muted-55'">
        <span class="h-2 w-2 rounded-full"
          [class]="store.isConnected() ? 'bg-pmdf-success' : 'bg-pmdf-border-strong'"></span>
        <span class="text-sm font-medium">
          Tempo real: {{ store.isConnected() ? 'Conectado' : 'Desconectado' }}
        </span>
        @if (store.isSubscribed()) {
          <span class="ml-auto text-xs font-medium text-pmdf-success">
            Monitorando proximidade
          </span>
        }
      </div>
    </div>

    <!-- Master toggle push -->
    <div class="flex items-center justify-between py-3 border-b border-pmdf-border-subtle">
      <div>
        <p class="text-sm font-semibold m-0">Notificações push habilitadas</p>
        <p class="text-xs text-pmdf-muted-55 m-0">Receber notificações mesmo com o app fechado</p>
      </div>
      <mat-slide-toggle
        [checked]="pushHabilitado()"
        (change)="onPushHabilitadoChange($event.checked)"
      />
    </div>

    <!-- Categorias de notificação -->
    @for (cat of categories; track cat.category) {
      <div class="py-3 border-b border-pmdf-border-subtle" [class.opacity-50]="!pushHabilitado()">
        <div class="flex items-center justify-between mb-2">
          <div class="flex items-center gap-2">
            <mat-icon class="icon-sm text-pmdf-primary">{{ cat.icon }}</mat-icon>
            <div>
              <p class="text-sm font-semibold m-0">{{ cat.label }}</p>
              <p class="text-xs text-pmdf-muted-55 m-0">{{ cat.description }}</p>
            </div>
          </div>
          <mat-slide-toggle
            [checked]="isCategoryEnabled(cat.category)"
            [disabled]="!pushHabilitado()"
            (change)="onCategoryToggle(cat.category, $event.checked)"
          />
        </div>

        @for (type of cat.types; track type.value) {
          <div class="flex items-center gap-2 py-1 ml-6">
            <mat-checkbox
              [checked]="isTypeEnabled(type.value)"
              [disabled]="!pushHabilitado() || !isCategoryEnabled(cat.category)"
              (change)="onTypeToggle(type.value)">
              <div class="flex items-center gap-2">
                <mat-icon class="icon-sm text-pmdf-muted-55">{{ type.icon }}</mat-icon>
                <span class="text-sm">{{ type.label }}</span>
              </div>
            </mat-checkbox>
          </div>
        }

        <!-- Raio de proximidade (apenas para Sentinela) -->
        @if (cat.category === SENTINELA) {
          <div class="ml-6 mt-2" [class.opacity-50]="!isCategoryEnabled(cat.category)">
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="w-full">
              <mat-label>Raio de proximidade</mat-label>
              <mat-select
                [value]="raioKm()"
                [disabled]="!pushHabilitado() || !isCategoryEnabled(cat.category)"
                (selectionChange)="onRaioChange($event.value)">
                @for (option of radiusOptions; track option.value) {
                  <mat-option [value]="option.value">{{ option.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      </div>
    }

    <!-- Som e vibração -->
    <div class="py-3" [class.opacity-50]="!pushHabilitado()">
      <p class="text-sm font-semibold mb-2 m-0">Feedback</p>
      <div class="flex items-center justify-between py-1">
        <div class="flex items-center gap-2">
          <mat-icon class="icon-sm text-pmdf-muted-55">volume_up</mat-icon>
          <span class="text-sm">Som de notificação</span>
        </div>
        <mat-slide-toggle
          [checked]="somHabilitado()"
          [disabled]="!pushHabilitado()"
          (change)="onSomChange($event.checked)"
        />
      </div>
      <div class="flex items-center justify-between py-1">
        <div class="flex items-center gap-2">
          <mat-icon class="icon-sm text-pmdf-muted-55">vibration</mat-icon>
          <span class="text-sm">Vibração</span>
        </div>
        <mat-slide-toggle
          [checked]="vibracaoHabilitada()"
          [disabled]="!pushHabilitado()"
          (change)="onVibracaoChange($event.checked)"
        />
      </div>
    </div>
  </mat-dialog-content>

  <!-- Footer -->
  <mat-dialog-actions align="end"
      class="px-6 py-4 gap-2 bg-pmdf-bg-subtle border-t border-pmdf-divider">
    <button mat-button type="button" (click)="onCancel()">Fechar</button>
    <button mat-raised-button color="primary" type="button" (click)="onSave()">
      Salvar
    </button>
  </mat-dialog-actions>

</div>
